/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { useFiche, FicheContainer } from '@mairistem/fiche';

import PacsFiche from './PacsFiche';

const PacsFicheContainer = () => {
  const [service] = useFiche('/api/administres/etat-civil/pacs');

  return (
    <FicheContainer service={service} type="pacs">
      {(p) => <PacsFiche {...p} />}
    </FicheContainer>
  );
};

export default PacsFicheContainer;
